/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * layoutPreferences.ts — layou\1 \2references (services/operator-web-app).
 */

/**
 * E4-S1 T3: Layout preferences persisted in localStorage.
 * Key prefix allows multiple apps in same origin.
 */

const STORAGE_KEY = 'operator.layout.copilotCollapsed';

export function getCopilotCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === 'true';
  } catch {
    return false;
  }
}

export function setCopilotCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    // quota or private mode
  }
}
